import React from 'react'
import { ThemeProvider } from 'styled-components'
import { mergedTheme } from '../../assets/theme/mergedTheme'

// @sweetalert/with-react (swal()) e sweetalert2 (Swal.fire + renderToString) renderizam o
// `content` numa árvore React desanexada da aplicação — sem ThemeProvider ancestral, props.theme
export const withPopupTheme = (content: React.JSX.Element): React.JSX.Element => (
  <ThemeProvider theme={mergedTheme}>
    {content}
  </ThemeProvider>
)
